import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { OutputHelper } from '../../interfaces/output-helper.interface';
import { OUTPUT_HELPERS_CONFIG } from '../../config/output-helpers.config';
import { OutputHelpersService } from '../../services/output-helpers/output-helpers.service';

@Component({
    selector: 'craig-output-helpers',
    templateUrl: './output-helpers.component.html',
    styleUrls: ['./output-helpers.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OutputHelpersComponent implements OnInit, OnDestroy {
    outputHelpersOptions: OutputHelper[] = OUTPUT_HELPERS_CONFIG();
    private readonly componentDestroyed$: Subject<boolean> = new Subject();

    constructor(
        private readonly outputHelpersService: OutputHelpersService,
        private readonly changeDetectorRef: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.outputHelpersService
            .clearOutputHelperOptionsChange()
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((isClear: boolean) => {
                if (isClear) {
                    this.deselectOptions();
                    this.changeDetectorRef.detectChanges();
                }
            });
    }

    onOptionClicked(id: number): void {
        this.toggleSelection(id);
        this.outputHelpersService.setSelectedOutputHelpersOption(this.outputHelpersOptions[id]);
    }

    ngOnDestroy(): void {
        this.componentDestroyed$.next(true);
    }

    private toggleSelection(id: number): void {
        this.outputHelpersOptions[id].isChecked = !this.outputHelpersOptions[id].isChecked;
    }

    private deselectOptions(): void {
        this.outputHelpersOptions.forEach((item: OutputHelper) => (item.isChecked = false));
    }
}
